export class DebounceElementObserver {
    constructor() {
        // карта, чтобы не обрабатывать элемент дважды
        this._processed = new WeakSet();

        // какие события смотрим и в каких атрибутах
        this._events = {
            onchange: 'change',
            onclick: 'click',
            oninput: 'input',
            onfocus: 'focus',
            onblur: 'blur',
            onenter: 'keydown',
        };

        this._mo = new MutationObserver(this._handleMutations.bind(this));
        this._mo.observe(document.body, { childList: true, subtree: true });

        // разово для уже вёрстанных
        this._initExisting(document.body);
    }

    _initExisting(root) {
        // выбираем все с атрибутом debounce
        root.querySelectorAll('[debounce]').forEach(el => {
            this._setupElement(el);
        });
    }

    _handleMutations(mutations) {
        for (const mut of mutations) {
            if (mut.type !== 'childList') continue;
            mut.addedNodes.forEach(node => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                // если сам элемент в зоне интереса
                if (node.hasAttribute('debounce')) {
                    this._setupElement(node);
                }
                // и все вложенные
                node.querySelectorAll?.('[debounce]').forEach(el => {
                    this._setupElement(el);
                });
            });
        }
    }

    _setupElement(el) {
        // уже инициализировано?
        if (this._processed.has(el)) return;
        this._processed.add(el);

        // читаем таймаут
        let wait = el.getAttribute('debounce');

        // пробегаем по всем интересующим нас событиям
        Object.entries(this._events).forEach(([attrName, evtName]) => {
            const debAttr = `debounce-${attrName}`;
            if (!el.hasAttribute(debAttr)) return;

            const code = el.getAttribute(debAttr);
            // eslint-disable-next-line no-new-func
            const rawFn = new Function('event', code);

            // Особая обработка для onenter
            if (attrName === 'onenter') {
                const dbFn = window.debounce(function (event) {
                    if (event.key === 'Enter') {
                        rawFn.call(this, event);
                    }
                }, wait, false);
                el.addEventListener(evtName, dbFn);
            } else {
                const dbFn = window.debounce(rawFn, wait, false);
                el.addEventListener(evtName, dbFn);
            }
        });
    }
}